import { cards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-18 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
          影视推荐
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          编辑精选高分影视作品，高清画质畅快观看
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <article
              key={card.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer transition-all duration-200 hover:border-primary-300"
            >
              <div className="relative overflow-hidden h-48">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
                  {card.tag}
                </span>
                <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-bold whitespace-nowrap">
                  {card.rating}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {card.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}